import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import customerAcquisitionPageData from '../data/servicePages/customerAcquisition';

const CustomerAcquisitionPage = () => <ServicePageLayout data={customerAcquisitionPageData} />;

export default CustomerAcquisitionPage;
